<lib-sticky-modal [height]="'40rem'">
  <lib-sticky-header>
    <div class="modal-header flex-container flex-align-center">
      <div class="modal-title">Select Displays</div>
      <lib-button-inline-text
        [class.disabled]="viewModel.disableClearButton$ | async"
        [textColor]="'#2c4058'"
        (buttonClicked)="viewModel.clearSelections()">
        Clear
      </lib-button-inline-text>
    </div>
    <app-search-with-look-ahead
      [placeHolder]="'Search by display name'"
      [lookAheadItems]="viewModel.currentLocationDisplays$ | async"
      [searchTheseProperties]="['name']"
      [disablePopper]="true"
      [nLookAheadItems]="10000"
      [outputAllItemsWhenSearchIsEmpty]="true"
      (lookAheadHits)="viewModel.connectToSearchedDisplays($event)">
    </app-search-with-look-ahead>
  </lib-sticky-header>
  <lib-sticky-body [position]="'relative'">
    <ng-container [ngSwitch]="(viewModel.searchedDisplays$ | async)?.length > 0">
      <div *ngSwitchCase="true" class="select-all-displays-container">
        <div fxLayout="row" fxLayoutAlign="start center">
          <app-group-selection
            #groupSelectionComponent
            [selection]="viewModel.displaysVisibleOnScreen$ | async"
            [selectedIds]="viewModel.selectedDisplayIds$ | async"
            (bulkAdd)="viewModel.addDisplayIds($event)"
            (bulkRemove)="viewModel.removeDisplayIds($event)">
          </app-group-selection>
          <div class="n-selected">
            <span *ngIf="viewModel.nSelectedDisplayIds$ | async as nSelected" class="checked-count">
              ({{ nSelected }})
            </span>
          </div>
        </div>
        <div class="select-all-locations-text">Select all displays</div>
      </div>
      <div *ngSwitchCase="false" class="pt-16px">No displays found.</div>
    </ng-container>
    <mat-accordion multi [displayMode]="'flat'">
      <ng-container
        *ngFor="
          let displayGrouping of viewModel.currentSearchDisplayGroupings$ | async;
          trackBy: viewModel.trackByTitle
        ">
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
          <mat-expansion-panel-header class="panel-header">
            <div class="flex-container flex-space-between flex-align-center">
              <app-group-selection
                [selection]="displayGrouping?.displays | getDisplaysAsSelection"
                [selectedIds]="viewModel.selectedDisplayIds$ | async"
                (bulkAdd)="viewModel.addDisplayIds($event)"
                (bulkRemove)="viewModel.removeDisplayIds($event)">
              </app-group-selection>
              <div class="n-selected">
                <span
                  *ngIf="
                    displayGrouping?.displays
                      | nDisplaysSelectedInGrouping: viewModel.selectedDisplayIds$
                      | async as nSelected
                  "
                  class="checked-count">
                  ({{ nSelected }})
                </span>
              </div>
              <div class="grouping-name">
                {{ displayGrouping?.title }}
              </div>
              <hr class="no-margin" />
            </div>
          </mat-expansion-panel-header>
          <app-location-display-selection-item
            *ngFor="let display of displayGrouping?.displays; trackBy: viewModel.trackById; let last = last"
            class="block ml-26px"
            [last]="last"
            [selection]="display"
            [selectedIds]="viewModel.selectedDisplayIds$ | async"
            (add)="viewModel.addDisplayIds([$event])"
            (remove)="viewModel.removeDisplayIds([$event])">
          </app-location-display-selection-item>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </lib-sticky-body>
  <lib-sticky-footer>
    <div class="flex-container flex-row flex-content-end" [style.gap.rem]="1">
      <lib-button-neutral (buttonClicked)="viewModel.closeModal()">Cancel</lib-button-neutral>
      <lib-button-primary
        [disabled]="(viewModel.selectedDisplayIds$ | async)?.length < 1"
        (buttonClicked)="viewModel.reloadDisplays()">
        Reload Display{{ (viewModel.selectedDisplayIds$ | async)?.length > 1 ? 's' : '' }}
      </lib-button-primary>
    </div>
  </lib-sticky-footer>
</lib-sticky-modal>
